import * as Yup from "yup";

const licensesCountRange = {
  min: 1,
  max: 5000000,
};

const requestPackLicensesCount = (minLicensesCount?: number, isPackRequest: boolean = false) => {
  let licenseCountValidationMessage = "Please enter a number larger than 0";

  if (minLicensesCount && minLicensesCount > 0) {
    licenseCountValidationMessage = isPackRequest
      ? `Value must be greater or equal to the number of licenses to assign: ${minLicensesCount}`
      : `Value must be greater than or equal to the current number of licenses in use. Current licenses:${minLicensesCount}`;
  }

  return Yup.number()
    .required("Number of Licenses is required")
    .min(
      minLicensesCount && minLicensesCount > 0 ? minLicensesCount : licensesCountRange.min,
      licenseCountValidationMessage,
    )
    .max(licensesCountRange.max, `Number of Licenses cannot exceed ${licensesCountRange.max.toLocaleString("en-US")}`);
};

export const validateLicensesCountInputValue = (input: string) => {
  return /^(0|[1-9]\d*)$/.test(input) || input === "";
};

export const packRequestValidationSchema = (minLicensesCount?: number, isPackRequest: boolean = false) =>
  Yup.object().shape({
    licensesCount: requestPackLicensesCount(minLicensesCount, isPackRequest),
    contactName: Yup.string()
      .trim()
      .required("Contact name is required")
      .max(128, "Contact name cannot exceed 128 characters"),
    contactPhone: Yup.string()
      .trim()
      .required("Contact phone is required")
      .min(13, "Please enter correct phone number"),
  });

export const enablePackValidationSchema = (unlimitedLicenses: boolean) => {
  return Yup.object().shape({
    licensesCount: unlimitedLicenses ? Yup.number().nullable().notRequired() : requestPackLicensesCount(0),
  });
};

export const packTrialRequestValidationSchema = Yup.object().shape({
  licensesCount: requestPackLicensesCount(0),
});
